import type { Signal } from "@builder.io/qwik";
import { createContextId } from "@builder.io/qwik";
import { type UserPreferencesSelect } from "~/lib/schemas";

export const UserPreferencesContext = createContextId<
  Signal<UserPreferencesSelect>
>("com.dreamcoachmatch.user-preferences");

export const UserPreferencesFormContext = createContextId<{
  steps: boolean[];
  currentStepIndex: number;
}>("com.dreamcoachmatch.user-preferences-form");
